export function isSafari() {
    const ua = navigator.userAgent.toLowerCase()
    return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('chromium')
}
export function isChromeOnMac() {
    const ua = navigator.userAgent.toLowerCase()
    const isMac = navigator.platform.toLowerCase().includes('mac')
    const isChrome = ua.includes('chrome') && !ua.includes('edge') && !ua.includes('opr')
    return isMac && isChrome
}
export function isChromeUseOnWindows() {
    const ua = navigator.userAgent.toLowerCase()
    const isWindows = navigator.platform.toLowerCase().includes('win')
    const isChrome = ua.includes('chrome') && !ua.includes('edge') && !ua.includes('opr')
    return isWindows && isChrome
}
export function isChrome() {
    const ua = navigator.userAgent.toLowerCase()
    return ua.includes('chrome') && !ua.includes('edge') && !ua.includes('opr')
}

export function isMax375() {
    return window.innerWidth <= 375
}
export function is600() {
    return window.innerWidth >= 600
}
export function is704() {
    return window.innerWidth >= 704
}
export function is1024() {
    return window.innerWidth >= 1024
}
export function isMobile() {
    return !is1024()
}
export function isMobileDevice() {
    if (window.Capacitor?.isNativePlatform()) return true
    if (navigator.userAgentData?.mobile) return true

    const userAgent = navigator.userAgent.toLowerCase()
    const platform = navigator.platform.toLowerCase()
    return /android|iphone|ipad|ipod/.test(userAgent)
        || (platform === 'macintel' && navigator.maxTouchPoints > 1)
}

export function isResolution(resolution) {
    return window.innerWidth >= resolution
}

export function mobileOnly() {
    return isMobile()
}
export function isCapacitor() {
    return window.Capacitor?.isNativePlatform() ?? false
}
